// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./wv-img-3.jpg");
var dir = previousRequest.replace("wv-img-3.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "wv-img-3.jpg",
	name: "wv-img-3",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/wv-img-3.jpg
// module id = 94
// module chunks = 4